import { registerPlugin } from '@capacitor/core'

export interface IBoxenBLEPlugin {
  sendSequencePayload(obj: { payload: string }): Promise<{ logEntries: [] }>
  cancel(): Promise<{ logEntries: [] }>
}

const IBoxenBLE = registerPlugin<IBoxenBLEPlugin>('IBoxenBLE')

export default IBoxenBLE
